import React from 'react'
import { connect } from "react-redux"
import Page from '../components/CoolPage'

import "./ConfirmationPage.less"

const ConfirmationPage = props => (
  <Page
    title="谢谢"
    isChevron={false}
    containerStyle={{ display: 'flex'}}
    containerProps={{ id: "ConfirmationPage" }}
  >
    <div className="weui-msg success" style={{ paddingTop: "0px", margin: "auto" }}>
      <div className="weui-msg__icon-area">
        <i className="weui-icon-success weui-icon_msg" />
      </div>
      <div className="weui-msg__text-area">
        <h2 className="weui-msg__title">完成提交</h2>
        <p className="weui-msg__desc">
          <p className="weui-msg__desc">感谢您通过{props.userInfo.partner ? props.userInfo.partner.name : "Chinespain"}自助订单系统提交的需求</p>
          <br />
          <p className="weui-msg__desc">我们的客服将尽快与您取得联系！</p>
        </p>
      </div>
      <div className="weui-msg__opr-area">
        <p className="weui-btn-area">
          <a href="/catalogo" className="weui-btn weui-btn_primary">返回首页</a>
        </p>
      </div>
      <div className="weui-msg__extra-area">
        <div className="weui-footer">
          <p className="weui-footer__links">
            <a href="http://chinespain.cn" className="weui-footer__link">http://chinespain.cn</a>
          </p>
          <p className="weui-footer__text">©2018 APPROACHING CULTURES SL.</p>
        </div>
      </div>
    </div>
  </Page>
)

const mapStateToProps = (state, _ownProps) => ({
  userInfo: state.userInfo,
})

export default connect(mapStateToProps)(ConfirmationPage)




// WEBPACK FOOTER //
// ./src/app/catalogo/reservation/ConfirmationPage.jsx